import React, { useState } from 'react';
import '../../App.css';
import '../../scss/App.scss';
import '../../scss/Hotel.scss';
import { Box, Container, Grid, Link } from '@mui/material';


function HotelDetail() {



  const features = [
    "Near park",
    "Near nightlife",
    "Near theater",
    "Clean Hotel"
  ];

  const rooms = [
    {
      id: 1,
      name: 'Superior room - 1 double bed or 2 twin beds',
      price: 2400,
      image: 'assets/hotel/hotel-card/hotel-card1.svg'
    },
    {
      id: 2,
      name: 'Superior room - City view - 1 double bed or 2 twin beds',
      price: 2800,
      image: 'assets/hotel/hotel-card/hotel-card1.svg'
    },
    {
      id: 3,
      name: 'Superior room - City view - 1 double bed or 2 twin beds',
      price: 3200,
      image: 'assets/hotel/hotel-card/hotel-card1.svg'
    },
    {
      id: 4,
      name: 'Superior room - City view - 1 double bed or 2 twin beds',
      price: 2350,
      image: 'assets/hotel/hotel-card/hotel-card1.svg'
    }
  ];

  const amenitiesData = [
    { img: 'pool.svg', label: 'Outdoor pool' },
    { img: 'pool.svg', label: 'Indoor pool' },
    { img: 'spa.svg', label: 'Spa and wellness center' },
    { img: 'Vector.svg', label: 'Restaurant' },
    { img: 'room-service.svg', label: 'Room service' },
    { img: 'fitness-center.svg', label: 'Fitness center' },
    { img: 'wine.svg', label: 'Bar/Lounge' },
    { img: 'wifi.svg', label: 'Free Wi-Fi' },
    { img: 'breakfast.svg', label: 'Tea/coffee machine' },
  ];


  const reviews = [
    {
      rating: '5.0',
      title: 'Amazing',
      name: 'Omar Siphron',
      image: 'reviewImg.svg',
      content:
        'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam...',
    },
    {
      rating: '5.0',
      title: 'Amazing',
      name: 'Cristofer Ekstrom Bothman',
      image: 'reviewImg.svg',
      content:
        'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam...',
    },
    {
      rating: '5.0',
      title: 'Amazing',
      name: 'Kaiya Lubin',
      image: 'reviewImg.svg',
      content:
        'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam...',
    },
    {
      rating: '5.0',
      title: 'Amazing',
      name: 'Erin Septimus',
      image: 'reviewImg.svg',
      content:
        'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam...',
    },
    {
      rating: '5.0',
      title: 'Amazing',
      name: 'Terry George',
      image: 'reviewImg.svg',
      content:
        'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam...',
    },
  ];

  const images = [
    '/assets/hotel/gallery/gallery-1.svg',
    '/assets/hotel/gallery/gallery-2.svg',
    '/assets/hotel/gallery/gallery-3.svg',
    '/assets/hotel/gallery/gallery-4.svg',
    '/assets/hotel/gallery/gallery-5.svg',
  ];

  return (
    <>



      <Container maxWidth="md" className="deals-header py-4 ">

        <Grid container spacing={2} justifyContent="center" >
        <Grid size={{ xl: 12, lg: 12, md: 12, sm: 12, xs: 12 }}>

          <div className="container hotel-header py-4 border-bottom">
      <div className="row align-items-center g-3">
        <div className='col-md-12'>
           <nav aria-label="breadcrumb" className="breadcrumb-wrapper mb-2">
      <ol className="breadcrumb mb-0">
        <li className="breadcrumb-item">
          <a href="#" className="text-decoration-none text-dark">India</a>
        </li>
        <li className="breadcrumb-item">
          <a href="#" className="text-decoration-none text-dark">Varanasi</a>
        </li>
        <li className="breadcrumb-item active" aria-current="page">
          Hotel Janki
        </li>
      </ol>
    </nav>
        </div>
        {/* Left column */}
        <div className="col-lg-9 col-md-8 col-sm-12">
          

          {/* Hotel name and rating */}
          <div className="d-flex align-items-center flex-wrap mb-1">
            <h3 className="hotel-name mb-0 me-3">Hotel Janki International</h3>
            <div className="stars d-flex align-items-center">
              {[...Array(5)].map((_, i) => (
                <i key={i} className="fa fa-star" ></i>
              ))}
              <span className="star-text ms-2">5 Star Hotel</span>
            </div>
          </div>

          {/* Address */}
          <div className="text-muted d-flex align-items-center mb-2">
            <i className="me-2 fa fa-map-marker" ></i>
            <small>D-59/105-7, Chandrika Nagar Colony, Sigra, Varanasi, Uttar Pradesh 221001</small>
          </div>

          {/* Review */}
          <div className="d-flex align-items-center">
            <div className="score-box me-2">4.2</div>
            <div>
              <strong>Very Good</strong> <span className="text-muted">371 reviews</span>
            </div>
          </div>
        </div>

        {/* Right column */}
        <div className="col-lg-3 col-md-4 col-sm-12 text-md-end text-sm-start d-flex flex-column gap-2 align-items-md-end align-items-sm-start">
          <div className=" fw-bold fs-4 priceColor">
            ₹1400 <small className="fs-6 fw-normal">/night</small>
          </div>

          <div className="d-flex gap-2">
            <button className="btn btn-outline-secondary btn-icon">
              <i className='fa fa-heart-o' ></i>
            </button>
            <button className="btn btn-outline-secondary btn-icon">
              <i className='fa fa-share-alt' ></i>
            </button>
            <a href="payment" className="btn btn-primary">Book now</a>
          </div>
        </div>
      </div>
    </div>
        </Grid>
          <Grid size={{ xl: 12, lg: 12, md: 12, sm: 12, xs: 12 }}>
            <div className=" py-4 hotel-gallery">
      <div className="row g-2">
        {/* Left large image */}
        <div className="col-md-6">
          <img src={images[0]} alt="Main" className="img-fluid rounded w-100 h-100 gallery-img" />
        </div>

        {/* Right side grid (2x2 images) */}
        <div className="col-md-6">
          <div className="row g-2 h-100">
            {images.slice(1, 5).map((img, index) => (
              <div className="col-6 position-relative" key={index}>
                <img src={img} alt={`Gallery ${index + 2}`} className="img-fluid rounded w-100 h-100 gallery-img" />
                
                {/* "View all photos" on bottom-right image */}
              
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>

          </Grid>
          <Grid size={{ xl: 12, lg: 12, md: 12, sm: 12, xs: 12 }}>
            <h2 className="hotelH2Heading">Overview</h2>
            <p className="deals-description mb-2">
              <span className='fontWeight'>Comfortable Accommodations:</span> Hotel Janki International Sigra in Varanasi offers air-conditioned rooms with private bathrooms, work desks, and free toiletries. Each room includes a TV, electric kettle, wardrobe, and slippers.
            </p>

            <p className="deals-description mb-2">
              <span className='fontWeight'>Dining Options:</span> Guests can enjoy a terrace restaurant serving buffet, à la carte, and full English/Irish breakfasts. The on-site restaurant provides a relaxing dining experience.
            </p>
            <p className="deals-description mb-2">
              <span className='fontWeight'>Convenient Facilities:</span> The hotel features free WiFi, a 24-hour front desk, and room service. Free on-site private parking is available for guests.
            </p>

            <p className="deals-description mb-2">
              <span className='fontWeight'>Local Attractions:</span> Located 26 km from Lal Bahadur Shastri International Airport, the hotel is close to Dasaswamedh Ghat, Kashi Vishwanath Temple, and other attractions.
            </p>
          </Grid>

          <Grid size={{ xl: 12, lg: 12, md: 12, sm: 12, xs: 12 }}>
            <div className="rating-summary d-flex  align-items-center flex-wrap gap-2">
              <div className="rating-box p-3 rounded">
                <div className="rating-value">4.2</div>
                <div className="rating-text">Very good</div>
                <div className="rating-reviews">371 reviews</div>
              </div>
              {features.map((feature, idx) => (
                <div key={idx} className="feature-box p-3 rounded d-flex align-items-center gap-4">
                  <img src="../assets/stars.svg" className='feature-icon img-fluid' alt="" />
                  <span>{feature}</span>
                </div>
              ))}
            </div>
          </Grid>
          <Grid size={{ xl: 12, lg: 12, md: 12, sm: 12, xs: 12 }}>
            <div className="room-list">
              <h2 className="hotelH2Heading mb-3">Available Rooms</h2>
              
              <div className="list-group">
                {rooms.map(room => (
                  <div
                    key={room.id}
                    className="list-group-item room-item d-flex align-items-center justify-content-between"
                  >
                    <div className="d-flex align-items-center gap-3">
                      <img src={room.image} alt="Room" className="room-img" />
                      <span>{room.name}</span>
                    </div>
                    <div className="d-flex align-items-center gap-3">
                      <span className="price">₹{room.price}<small>/night</small></span>
                      <a href="payment" className="btn btn-teal">Book now</a>
                    </div>
                  </div>
                ))}
              </div>
            </div>



            <Grid size={{ xl: 12, lg: 12, md: 12, sm: 12, xs: 12 }}>
              <div className="location-map container my-5 ">
                <div className="locationMap mb-3">
                  <h2 className="hotelH2Heading">Location/Map</h2>
                  <a
                    href="https://www.google.com/maps/place/D-59%2F105-7,+Chandrika+Nagar+Colony,+Sigra,+Varanasi,+Uttar+Pradesh+221001"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn btn-teal"
                  >
                    View on google maps
                  </a>
                </div>

                <div className="map-container mb-2">
                  <iframe
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d224113.1985158308!2d77.03954878671874!3d28.636692800000006!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390cfb2b7666fef5%3A0xa24a557ac91e9ab!2sRadisson%20Blu%20Hotel%2C%20Kaushambi%20Delhi%20NCR!5e0!3m2!1sen!2sin!4v1755933604469!5m2!1sen!2sin"
                    width="100%"
                    height="300"
                    style={{ border: 0, borderRadius: '10px' }}
                    allowFullScreen=""
                    loading="lazy"
                  ></iframe>

                </div>

                <div className="address d-flex align-items-center gap-2">
                  <i className="fa fa-map-marker" ></i>
                  <p className="mb-0">
                    D-59/105-7, Chandrika Nagar Colony, Sigra, Varanasi, Uttar Pradesh 221001
                  </p>
                </div>
              </div>
            </Grid>


            <Grid size={{ xl: 12, lg: 12, md: 12, sm: 12, xs: 12 }}>
              <div className="amenities-container container py-4">
                <h2 className="hotelH2Heading mb-3">Amenities</h2>
                <div className="row">
                  {amenitiesData.map((amenity, index) => (
                    <div className="col-12 col-sm-6 d-flex align-items-center mb-3" key={index}>
                      <img
                        src={`/assets/hotel/amanities/${amenity.img}`}
                        alt={amenity.label}
                        className="amenity-icon me-2"
                      />
                      <span>{amenity.label}</span>
                    </div>
                  ))}
                  <div className="col-12 col-sm-6 mt-2">
                    <span className="more-link text-danger">+24 more</span>
                  </div>
                </div>
              </div>
            </Grid>

            <Grid size={{ xl: 12, lg: 12, md: 12, sm: 12, xs: 12 }}>
              <div className="reviews-section container py-4">
                <div className="d-flex justify-content-between align-items-center mb-4">
                  <h5 className="fw-bold mb-0">Reviews</h5>
                  <button className="btn btn-primary btn-sm">Give your review</button>
                </div>

                <div className="review-summary mb-4">
                  <h1 className="display-4 fw-bold mb-0">4.2</h1>
                  <div>
                    <p className="fs-6 mb-0">Very good</p>
                    <small className="text-muted ">371 verified reviews</small>
                  </div>
                </div>

                <div className="review-list">
                  {reviews.map((review, index) => (
                    <div className="review-item d-flex mb-4 pb-3 border-bottom" key={index}>
                      <img
                        src={`/assets/hotel/${review.image}`}
                        alt={review.name}
                        className="review-avatar rounded-circle me-3"
                      />
                      <div>
                        <div className="fw-semibold">
                          {review.rating} <span className="text-muted">{review.title}</span>{' '}
                          <span className="text-secondary">| {review.name}</span>
                        </div>
                        <p className="mb-0 small text-muted">{review.content}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </Grid>
          </Grid>
        </Grid>
      </Container>




    </>
  );
}
export default HotelDetail;